<div class="entity-container">
  <rappider-ai-crud-view [activeEntityConfig]="activeEntityConfig"
                         [entityConfigs]="[activeEntityConfig]"
                         [defaultEntityNameIfNotSelected]="activeEntityConfig?.name"
                         [changeActiveEntityConfigWithQueryParams]="false"
                         [displayGripButton]="false"
                         [addListGridItemDefaultActions]="false"
                         (entitySelected)="onEntitySelected($event)"
                         (doneClick)="onJoyrideDoneButtonClick()"
                         (entityItemSelected)="onEntityItemSelected($event)"></rappider-ai-crud-view>
</div>
<!-- <pre>{{activeEntityConfig | json}}</pre> -->
